export default "__VITE_ASSET__54478111__"